export default function R_Math() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Math Component</h1>
      <p>This is the R_Math tutorial section.</p>
    </div>
  );
}
